import { CUSTOMERS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import {
  IContactPerson,
  ICustomer,
  ICustomerImportResult,
} from "../../shared/interfaces/customer/ICustomer";

export const CustomerService = {
  get: (pagination: IPagination): Promise<IBaseModel<ICustomer[]>> =>
    requests.get(CUSTOMERS_URL, pagination),
  getSingle: (id: number): Promise<ICustomer> =>
    requests.get(`${CUSTOMERS_URL}/${id}`),
  create: (params: FormData) => requests.post(CUSTOMERS_URL, params, true),
  update: (params: FormData, id: number) =>
    requests.put(`${CUSTOMERS_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${CUSTOMERS_URL}/${id}`),
  upload: (formData: FormData): Promise<ICustomerImportResult> =>
    requests.post(`${CUSTOMERS_URL}/upload`, formData, true),
  deleteContactPerson: (id: number) =>
    requests.delete(`${CUSTOMERS_URL}/contact-person/${id}`),
};
